import { IconBase } from 'react-icons';
import * as React from 'react';

export const Chain = props => (

  <IconBase viewBox="0 0 22.6 22.6" {...props}>
  <path transform="rotate(-45 11.31 11.31)" fill="none" stroke="#fff" d="M10.8 5.8h1v11h-1z"/>
  <path
    fill="none"
    stroke="#fff"
    strokeWidth="1.5"
    // eslint-disable-next-line max-len
    d="M16.4 10.4l4.2 4.2c.5.5.5 1.3 0 1.8l-4.2 4.2c-.5.5-1.3.5-1.8 0l-4.2-4.2c-.5-.5-.5-1.3 0-1.8l4.2-4.2c.6-.5 1.4-.5 1.8 0zM8 1.9l4.2 4.2c.5.5.5 1.3 0 1.8L8 12.2c-.5.5-1.3.5-1.8 0L1.9 8c-.5-.5-.5-1.3 0-1.8L6.1 2c.6-.5 1.4-.5 1.9-.1z"
  />
  </IconBase>
);

/*
<svg id="shape" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.6 22.6">

</svg>
*/
